import { Group, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import React from "react";
import imageLogo from "../../../assets/images/logoE-sign.png";

interface ErrorStateProps {
  /** Mã lỗi hiển thị lớn, ví dụ 404 / 403 / 500 */
  code?: string | number;
  /** Màu Mantine chủ đạo cho icon + mã lỗi */
  color?: string;
  /** Icon minh hoạ (Tabler icon) */
  icon: React.ReactNode;
  title: string;
  description: string;
  /** Các nút hành động (Button) */
  actions?: React.ReactNode;
}

/**
 * Khung trang lỗi dùng chung, gắn thương hiệu E-sign.
 * Dùng cho 404 / 403 / lỗi hệ thống để đồng nhất giao diện.
 */
export function ErrorState({
  code,
  color = "blue",
  icon,
  title,
  description,
  actions,
}: ErrorStateProps) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background: "linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)",
      }}
    >
      <Stack
        align="center"
        gap="md"
        style={{ maxWidth: 520, textAlign: "center" }}
      >
        <img
          src={imageLogo}
          alt="E-sign"
          style={{ height: 40, objectFit: "contain", marginBottom: 8 }}
        />

        <ThemeIcon size={104} radius="xl" variant="light" color={color}>
          {icon}
        </ThemeIcon>

        {code != null && (
          <Text fw={800} fz={44} c={`${color}.6`} lh={1}>
            {code}
          </Text>
        )}

        <Title order={2} c="dark.7">
          {title}
        </Title>

        <Text c="dimmed" size="md" style={{ maxWidth: 440 }}>
          {description}
        </Text>

        <Group mt="sm" justify="center">
          {actions}
        </Group>
      </Stack>
    </div>
  );
}

export default ErrorState;
